import React from 'react';
import ReactDOM from 'react-dom/client';
import './assets/globals.css';
import App from './App';
import { applyCountryTheme } from './services/country';

applyCountryTheme();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);

if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => navigator.serviceWorker.register('/service-worker.js'));
}
